// extracted by mini-css-extract-plugin
export var addressFields = "_p7-0";
export var animationContainer = "_p7-1";
export var footer = "_p7-2";
export var lineItems = "_p7-3";
export var modalContent = "_p7-4";
export var orderName = "_p7-5";
export var strong = "_p7-6";
export var warning = "_p7-7";